import lazySizes from 'vendor.lazysizes';

class SectionNewsletter extends HTMLElement {
  constructor() {
    super();

    // Support for background images with new Lazysizes library
    this.addEventListener('lazyloaded', (e) => {
      const mobileBg = e.target.getAttribute('data-mobile-bg');
      let bg = e.target.getAttribute('data-bg');

      if (bg) {
        if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
          bg = mobileBg;
        }
        e.target.style.backgroundImage = `url(${bg})`;
      }
    });

    lazySizes();
  }
}

customElements.define('section-newsletter', SectionNewsletter);
